export function dataInRequest(params = {}) {
  return {
    type: '@edicaoAlinhamentoTanque/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@edicaoAlinhamentoTanque/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@edicaoAlinhamentoTanque/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@edicaoAlinhamentoTanque/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params, url) {
  return {
    type: '@edicaoAlinhamentoTanque/UPDATE_DATA',
    payload: { data, params, url },
  };
}

export function storeData(data, params) {
  return {
    type: '@edicaoAlinhamentoTanque/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@edicaoAlinhamentoTanque/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@edicaoAlinhamentoTanque/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@edicaoAlinhamentoTanque/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@edicaoAlinhamentoTanque/RECORD_FILTERING',
    payload: { params },
  };
}
